<template>
  <div class="tool-tip" :style="{ backgroundColor: backgroundColor }">
    <div class="icon-wrapper">
      <img :src="iconPath">
    </div>
    <div class="text-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolTip',
  props: {
    iconPath: {
      type: String,
    },
    backgroundColor: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@riseupil/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .tool-tip {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    background-color: $riseup_light_blue; // Default background color

    .icon-wrapper {
      padding-top: 4px;
      margin-left: 15px;
    }

    .text-wrapper {
      flex-grow: 1;
    }
  }
</style>
